<script lang="ts">
    import Fa from 'svelte-fa'
    import { faAngleLeft, faPlusCircle, faSave, faTrashAlt, faUser } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, get_current_component, onMount } from 'svelte/internal'
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import Zgrid from '../_common/z/zgrid.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridItemShow, GridLine } from '../_common/z/zgrid'
    import Zframe from '../_common/z/zframe.svelte'
    import Zact from '../_common/z/zact.svelte'
    import { Partner } from '../../modules/toolsApi/partners/partners/partner.entity'
    import type { CreatePartnerDto } from '../../modules/toolsApi/partners/partners/dto/create-partners.dto'
    import type { UpdatePartnerDto } from '../../modules/toolsApi/partners/partners/dto/update-partners.dto'
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    const dispatch = createEventDispatcher()

    const me = get_current_component()

    let show = false
    let step = 1
    let entities: Partner[] = []
    let entity: Partner = new Partner()

    onMount(async () => {
        await loadEntities()
    })

    async function loadEntities() {
        try {
            show = true
            entities = []
            entities = await window.api.tools.partners.partners.getAll()
            entities = await window.api.utils.utils.assignPersonsFromObject(entities)
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function editEntity(id: string) {
        try {
            show = true
            entity = new Partner()
            entity = await window.api.tools.partners.partners.getOne(id)
            console.log('partner', entity)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        entity = new Partner()
        step = 2
    }

    async function saveEntity() {
        if (entity.partnerId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function createEntity() {
        try {
            show = true
            const dto: CreatePartnerDto = {
                personId: entity.personId || entity.person.personId,
                comissionPercent: entity.comissionPercent,
                paymentDelay: entity.paymentDelay,
                notes: entity.notes,
                pix: entity.pix,
            }
            entity = await window.api.tools.partners.partners.create(dto)
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            show = true
            const dto: UpdatePartnerDto = {
                comissionPercent: entity.comissionPercent,
                paymentDelay: entity.paymentDelay,
                personId: entity.personId || entity.person.personId,
                notes: entity.notes,
                pix: entity.pix,
            }
            await window.api.tools.partners.partners.update(entity.partnerId, dto)
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function sendClose() {
        dispatch('close')
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.tools.partners.partners.remove(entity.partnerId)
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Parceiros'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Parceiro' }))
        grid.cols.push(new GridCol({ content: 'ID' }))
        grid.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            let btnPerson = new GridButton({
                icon: faUser,
                label: '',
                mobile: GridItemShow.hide,
                callback: () => {
                    window.person('show', item.person?.personId)
                },
            })

            let btnEdit = new GridButton({
                callback: () => editEntity(item.partnerId),
                label: 'Editar',
            })

            let line: GridLine = new GridLine()
            line.slots.push({ content: item.person.name })
            line.slots.push({ content: item.partnerId })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: [btnPerson, btnEdit] })
            grid.lines.push(line)
        }
    }
</script>

<Content>
    {#if step === 1}
        <Zact>
            <div class="spacer" />
            {#if window.store.token.permissions.partnership.partners.write}
                <button class="btn btn-secondary" on:click={newEntity}><Fa icon={faPlusCircle} /> Novo parceiro</button>
            {/if}
        </Zact>
        <Zgrid class="h-space" {grid} />
    {/if}
    {#if step === 2}
        <Zact>
            <button class="btn btn-secondary" on:click={showEntities}><Fa icon={faAngleLeft} /> Voltar</button>
            <div class="spacer" />
            {#if !!entity.partnerId}
                <button class="btn btn-warning me-1" on:click={removeEntity}><Fa icon={faTrashAlt} /> Excluir</button>
            {/if}
            <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
        </Zact>

        <Zframe title="Parceiro" class="h-space">
            <div class="grid-form">
                <div class="row">
                    <div class="col-6">
                        <ZentitySelect fonte="pessoa" label="Parceiro" bind:value={entity.person} />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="input-group">
                            <label for="" class="input-group-text">Comissão</label>
                            <input type="number" bind:value={entity.comissionPercent} class="form-control" />
                            <label for="" class="input-group-text">%</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="input-group">
                            <label for="" class="input-group-text">Prazo para pagamento</label>
                            <input type="number" bind:value={entity.paymentDelay} class="form-control" />
                            <label for="" class="input-group-text">dias</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="input-group">
                            <label for="" class="input-group-text">Chave Pix</label>
                            <input type="text" bind:value={entity.pix} class="form-control" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="input-group">
                            <label for="" class="input-group-text">Anotações</label>
                            <textarea bind:value={entity.notes} class="form-control" />
                        </div>
                    </div>
                </div>
            </div>
        </Zframe>
    {/if}
    {#if step === 3}
        <!-- <AudienceShow on:close={showEntities} {audienceId} /> -->
    {/if}
</Content>
<LoadSpinner {show} />
